<template>
    <div class="user-list">
        <el-form :inline="true" class="demo-form-inline" :loading="loading" size="mini">
            <el-form-item>
                <el-input placeholder="输入昵称搜索" v-model="filter.nickname"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input placeholder="手机号" v-model="filter.phoneNumber"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input placeholder="姓名" v-model="filter.realName"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input placeholder="用户id" v-model.number="filter.userId"></el-input>
            </el-form-item>
            <!--
      <el-form-item label="账号状态">
        <el-select v-model="filter.isDeleted">
          <el-option label="全部" value=""></el-option>
          <el-option label="可用" :value="false"></el-option>
          <el-option label="已禁用" :value="true"></el-option>
        </el-select>
      </el-form-item>
    -->
            <el-form-item label="审核状态">
                <el-select v-model="filter.checkStatus">
                    <el-option value="" label="全部"></el-option>
                    <el-option v-for="val,key in checkStatus" :key="key" :value="key" :label="val"></el-option>
                </el-select>
            </el-form-item>
            <!--<el-form-item label="入驻状态">-->
            <!--<el-select v-model="filter.isPartyB" placeholder="入驻状态">-->
            <!--<el-option value="" label="全部"></el-option>-->
            <!--<el-option :value="true" label="已入驻"></el-option>-->
            <!--<el-option :value="false" label="未入驻"></el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <el-form-item>
                <el-button @click="search">搜索</el-button>
            </el-form-item>
            <!--<el-form-item>-->
            <!--<el-button-group>-->
            <!--<el-button @click="add_form.visible=true" size="mini">增加</el-button>-->
            <!--</el-button-group>-->
            <!--</el-form-item>-->
        </el-form>
        <el-table :data="list" size="mini">
            <el-table-column type="expand" v-if="false">
                <template slot-scope="scope">
                    <el-form size="mini">
                        <el-form-item label="用户状态">
                            <el-radio-group v-model="scope.row.checkStatus">
                                <el-radio-button label="-1">审核未通过</el-radio-button>
                                <el-radio-button label="0">未认证</el-radio-button>
                                <el-radio-button label="1">未审核</el-radio-button>
                                <el-radio-button label="2">已认证</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label=" ">
                            <el-button type="primary" @click="update(scope.row)">保存</el-button>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <!--
            <el-table-column prop="userId" label="userId"></el-table-column>
            -->
            <!--
      <el-table-column label="账号状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isDeleted" type="danger" size="mini">已禁用</el-tag>
          <el-tag v-else size="mini">可用</el-tag>
        </template>
      </el-table-column>
      -->
            <el-table-column prop="avatar" label="头像">
                <template slot-scope="scope">
                    <img :src="scope.row.avatar || 'static/headshot-default.png'" width="50" height="50" />
                </template>
            </el-table-column>
            <el-table-column label="姓名">
                <template slot-scope="scope">
                    {{scope.row.realName || '空'}}
                </template>
            </el-table-column>
            <el-table-column prop="role" label="角色">
                <template slot-scope="scope">
                    {{scope.row.role ? (scope.row.role === 1 ? '甲方' : '乙方') : '空'}}
                </template>
            </el-table-column>
            <el-table-column prop="nickname" label="昵称">
                <template slot-scope="scope">
                    <a :href="`${frontUrl}/resume/detail/${scope.row.userIdEnc}`" target="_blank">{{scope.row.nickname}}</a>
                </template>
            </el-table-column>
            <!--
            <el-table-column prop="phoneNumber" label="电话">
                <template slot-scope="scope">
                    {{scope.row.phoneNumber || '空'}}
                </template>
            </el-table-column>
            -->
            <!--
            <el-table-column prop="email" label="邮箱" width="150px">
                <template slot-scope="scope">
                    {{scope.row.email || '空'}}
                </template>
            </el-table-column>
        -->
            <!--
      <el-table-column label="入驻状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.checkStatus == 2 " size="mini" type="primary">已入驻</el-tag>
          <el-tag v-else>未入驻</el-tag>
        </template>
      </el-table-column>
    -->
            <el-table-column label="审核">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.checkStatus == 0 " size="mini" type="warning">未认证</el-tag>
                    <el-tag v-if="scope.row.checkStatus == 1 " size="mini" type="warning">未审核</el-tag>
                    <el-tag v-if="scope.row.checkStatus == 2 " size="mini" type="primary">已认证</el-tag>
                    <el-tag v-if="scope.row.checkStatus == -2 " size="mini" type="danger">审核未通过</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="rejectReason" label="驳回原因">
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <a target="_blank" :href="`/user-detail?userId=${scope.row.userIdEnc}`">详情</a>
                </template>
            </el-table-column>
        </el-table>
        <br/>
        <div style="float: right">
            <el-pagination background layout="prev, pager, next" :page-size="20" @current-change="i=>pageNum=i" :page-count="pageNum" :total="total" ref="pagination">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import request from '../request'
import map from '../../datamap'
import api from '../api'

const url = '/user/listUserByParam'

let {
    user
} = api

// const check = '/user/checkUser'
export default {
    name: 'user-list',
    data() {
        return {
            loading: true,
            list: [],
            user_map: map.user,
            total: 0,
            pageNum: 1,
            limit: 20,
            filter: {
                nickname: '',
                checkStatus: '1',
                phoneNumber: '',
                userId: '',
                realName: '',
                // isPartyB: '',
                // isDeleted: '',
            },
            checkStatus: {
                '0': '未认证',
                '1': '待审核',
                '2': '已认证',
                '-2': '审核不通过',
                '3': '全部',
            }
        }
    },
    watch: {
        pageNum() {
            this.fetch()
        },
    },
    methods: {
        async fetch() {
            let pageNum = this.page
            let {
                nickname,
                checkStatus,
                userId,
                phoneNumber,
                realName,
                // isPartyB,
                // isDeleted
            } = this.filter
            let res = await user.listCheck({
                pageNum: this.pageNum,
                limit: this.limit,
                nickName: nickname,
                realName,
                // isDeleted,
                userId: Number.isInteger(userId) ? userId : '',
                phoneNumber,
                // isPartyB,
                checkStatus,
            })
            this.list = res.data.data
            this.total = res.data.pageinfo.totalCount
        },

        async remove(item) {
            try {
                await this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                let {
                    userId
                } = item
                let res = await api.user.remove({
                    userId
                })
                if (res.data.code === 200) {
                    this.$message.success('删除数据成功')
                    this.fetch()
                }
            } catch (e) {
                this.$message.success('删除数据失败')
            }
        },
        async update(item) {
            let {
                userId,
                checkStatus
            } = item
            const {
                data: {
                    code
                }
            } = await user.check({
                userId: this.userId,
                checkStatus: this.data.checkStatus,
                rejectReason: ''
            })
            if (code === 200) {
                this.$message.success('更新用户成功')
                this.getUserById()
            }
        },
        async goDetail(userId) {
            this.$router.push({
                path: `/user-detail?userId=${userId}`
            })
        },
        async search() {
            this.$refs.pagination.internalCurrentPage = 1
            this.pageNum = 1
            this.fetch()
        },
        handleCommand(command) {
            let action = command.action;
            let data = command.data;
            switch (action) {
                case 'clear':
                    this.cleanCertification(data);
                    break;
                default:
            }
        },
        async cleanCertification(row) {
            if (confirm('是否确认清除用户认证信息')) {
                let obj = {
                    userId: row.userId,
                }
                let {
                    data: {
                        code
                    }
                } = await user.cleanCertification(obj)
                if (code == 200) {
                    this.$message.success('认证信息清除更新成功')
                    this.fetch()
                }
            }
        }
    },
    mounted() {
        this.fetch()
    },
}
</script>
<style>
.user-list {}
</style>


// WEBPACK FOOTER //
// src/views/user/user-check.vue